import { DataBean } from "../DataBean";

export class AccountINFORPO extends DataBean {
  public async getAffiliateInforpo(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getAffiliateInforpo_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getCreditAffiliateInforpo(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getCreditAffiliateInforpo_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getCuotasCreditoInforpo(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getCuotasCreditoInforpo_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getAdministratedCreditAffiliateInforpo(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getAdministratedCreditAffiliateInforpo_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getHistoriaCreditoInforpo(
    page: number,
    rows: number,
    props: any
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getHistoriaCreditoInforpo_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async searchCreditAffiliateByNit(Nit: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.credit.bean.CreditAffiliate_searchCreditAffiliateByNit_Number",
      [Nit]
    );
  }

  public async getCreditAffiliateCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_getCreditAffiliateCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getCarteraRender(page: number, rows: number, props: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.advantage.shared.Report_getCarteraRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async getAmortizacionRender(page: any, maxRows: number, props: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.advantage.shared.Report_getAmortizacionRender_Number_Number_java.util.Map",
      [page, maxRows, props]
    );
  }

  public async getMovimientosRender(properties: any, maxRows: number, props: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.advantage.shared.Report_getMovimientosRender_Number_Number_java.util.Map",
      [properties, maxRows, props]
    );
  }

  public async getCreditAmountByAffiliate(idCreditAffiliate: number, year: number, month: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_getCreditAmountByAffiliate_Number_Number_Number",
      [idCreditAffiliate, year, month]
    );
  }
  public async getCreditAmountByAccount(idAccount: number, year: number, month: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_getCreditAmountByAccount_Number_Number_Number",
      [idAccount, year, month]
    );
  }
  public async deleteCreditHistory(id: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "boolean_deleteCreditHistory_Number",
      [id]
    );
  }
  public async updateCreditHistory(bean: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.credit.bean.CreditHistory_updateCreditHistory_com.credit.bean.CreditHistory",
      [{ DataBeanProperties: bean, DataBeanName: "com.credit.bean.CreditHistory" }]
    );
  }
  public async actualizarAmortizacion(idCreditAffiliate: number, idCreditAccount: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "void_actualizarAmortizacion_Number_Number",
      [idCreditAffiliate, idCreditAccount]
    );
  }
  public async getAccount(idAccount: number): Promise<any> {
    return this.getCustomService(
      "OrangeBase",
      "com.advantage.bean.account.AbstractAccount_getAccount_Number",
      [idAccount]
    );
  }
}
